import React, { useEffect, useContext } from 'react'
import styled from 'styled-components'
import { useIntl, Link } from 'gatsby-plugin-intl'
import { LinkPlaceholder } from 'src/components/Typography'
import routes from 'src/utils/routes'
import { MENU_ITEMS } from 'src/features/dashboard/duck/consts'
import PermissionsContext from 'src/utils/permissions'
import HeaderLoggedIn, {
  HeaderGroup
} from 'src/components/header/HeaderLoggedIn'
import { Page } from 'src/components/Wrappers'
import { AddOfferButton } from 'src/components/atoms/Buttons'
import { EXCHANGE_API_URL_PREFIXES } from 'src/ducks/consts'
import { canAddOffer } from 'src/features/offers/utils/exchangePermissions'
import OfferHistoryDetails from './components/OfferDetails/OfferHistoryDetails'
import useActiveDrawerOffer from './components/OfferDetails/useActiveDrawerOffer'
import FreeCarriersOffersList from './components/lists/FreeCarriersOffersList'
import ExchangeOffersView from './components/map/ExchangeOffersView'
import { EXCHANGE_MAP_TYPES } from './components/map/offerMapUtils'
import Drawer from './components/Drawer'
import { connectFreeCarriers } from './ducks/connectors'
import StockHeader from './components/StockHeader.jsx'
import { ListWrapper, ContentWrapper } from './components/atoms'
import FreeCarriersFilters from './components/filters/FreeCarriers'

const StockFreeCarriers = ({
  className,
  getOffers,
  setDrawerState,
  isDrawerOpen,
  offers,
  pagination,
  selectedOfferId,
  setFilter,
  showOffer,
  stock
}) => {
  const intl = useIntl()
  const {
    drawerOfferType,
    resetDrawerOffer,
    selectDrawerOffer,
    selectHistoryOffer,
    selectedOfferId: activeOfferId,
    selectedOfferType: activeOfferType
  } = useActiveDrawerOffer(EXCHANGE_MAP_TYPES.FREE_CARRIERS, selectedOfferId)
  const permissions = useContext(PermissionsContext)
  const hasPermissionToAddOffer = canAddOffer(
    EXCHANGE_API_URL_PREFIXES.FREE_CARRIERS,
    permissions
  )

  useEffect(() => {
    getOffers()
    return () => {
      setDrawerState(false)
    }
  }, [])
  const closeDrawer = () => {
    resetDrawerOffer()
    setDrawerState(false)
  }

  return (
    <Page
      className={className}
      contentPadding={0}
      topBar={
        <HeaderLoggedIn>
          <HeaderGroup withMobileAction={hasPermissionToAddOffer}>
            <StockHeader withDropdown>
              {intl.formatMessage({ id: 'offers.vehiclesExchangeTitle' })}
            </StockHeader>
            {hasPermissionToAddOffer && (
              <Link
                to={`${routes.APP_DASHBOARD}?tab=${MENU_ITEMS.OFFER_FORM_FREE_CARRIERS}`}
              >
                <AddOfferButton active />
              </Link>
            )}
          </HeaderGroup>
        </HeaderLoggedIn>
      }
    >
      <ContentWrapper>
        <ListWrapper>
          <ExchangeOffersView
            exchangeType={EXCHANGE_MAP_TYPES.FREE_CARRIERS}
            drawerOfferType={activeOfferType}
            filters={<FreeCarriersFilters />}
            isDrawerOpen={isDrawerOpen}
            onDrawerOfferTypeChange={selectDrawerOffer}
            offers={offers}
            pagination={pagination}
            selectedOfferId={activeOfferId}
            selectedOfferType={activeOfferType}
            setDrawerState={setDrawerState}
            setFilter={setFilter}
            showOffer={showOffer}
            stock={stock}
          >
            <FreeCarriersOffersList trigger={isDrawerOpen} />
          </ExchangeOffersView>
        </ListWrapper>
        <Drawer open={isDrawerOpen} onClose={closeDrawer}>
          <OfferHistoryDetails
            defaultOfferType={EXCHANGE_MAP_TYPES.FREE_CARRIERS}
            isOpen={isDrawerOpen}
            offerType={drawerOfferType}
            onActiveOfferChange={selectHistoryOffer}
            onClose={closeDrawer}
            onOfferTypeChange={selectDrawerOffer}
            selectedOfferId={`${activeOfferType}:${activeOfferId || ''}`}
          />
        </Drawer>
      </ContentWrapper>
    </Page>
  )
}

const StyledStockFreeCarriers = styled(StockFreeCarriers)`
  ${LinkPlaceholder} {
    margin-bottom: 1.2rem;
  }
`

export default connectFreeCarriers(StyledStockFreeCarriers)
